import { useState } from "react";
import Sidebar from "./components/Header/Sidebar"
import Header from "./components/Header/Index"
import HeaderLogin from "./components/Header/HeaderLogin"
import StickyHeaderMenu from "./components/Header/StickyHeaderMenu";
import './Layout.css'
import NotificationPopover from './components/Header/NotificationPopover'
import Footer from "components/Footer";
import MobileSidebarDrawer from './components/Header/MobileSidebarDrawer'
interface LayoutProps {
  className?: string;
  contentClassName?: string;
  children?: React.ReactNode;
}

export default function DashboardLayout({ className, contentClassName, children }: LayoutProps) {
  const [drawerOpen, setDrawerOpen] = useState(false)
  const [notifyOpen, setNotifyOpen] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem('token') ? true : false);
  return (
    <div>
      <Sidebar onToggleNotify={() => setNotifyOpen(prev => !prev)} />

      <div>
        {!isLoggedIn && (
          <HeaderLogin onLoginSuccess={() => setIsLoggedIn(true)} />
        )}
        {isLoggedIn && (
          <Header onOpenMenu={() => setDrawerOpen(true)} />
        )}
        {isLoggedIn && (
          <StickyHeaderMenu />
        )}
        <main>
          {children}
        </main>
      </div>
      <Footer />
      <MobileSidebarDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      />
      <NotificationPopover
        open={notifyOpen}
        onClose={() => setNotifyOpen(false)}
      />
    </div>
  )
}